"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./../../DiplomaRequest.module.css"));
var COLLEGE = {
    CA: {
        address1: "1215 HOWE AVE SUITE 101",
        city: "SACRAMENTO",
        zip: "95825-2401",
        phone: "(916) 649-9600",
        fax: "(916) 649.9700"
    },
    NV: {
        address1: "6029 W. CHARLESTON BLVD",
        city: "LAS VEGAS",
        zip: "89146",
        phone: "702-836-9900",
        fax: "702.836.3583"
    },
    TX: {
        address1: "9330 LYNDON B.JOHNSON FREEWAY",
        city: "DALLAS",
        zip: "75243",
        phone: "972-248-9000",
        fax: "972-248-0125"
    }
};
function Header(props) {
    return (react_1.default.createElement("header", null,
        react_1.default.createElement("div", { className: "row " + styles.paddintTopContent },
            react_1.default.createElement("div", { className: "col-xs-6 col-md-6" },
                react_1.default.createElement("img", { className: styles.imageLogo, alt: "logo", src: "/img/asher-logo.png" })),
            react_1.default.createElement("div", { className: "col-xs-2 col-md-2" }),
            react_1.default.createElement("div", { className: "col-xs-4 col-md-4" },
                react_1.default.createElement("div", { className: styles.textRight + " " + styles.borderContainer },
                    react_1.default.createElement("span", null,
                        "ASHER COLLEGE",
                        react_1.default.createElement("br", null),
                        COLLEGE[props.stateSelected].address1,
                        react_1.default.createElement("br", null), COLLEGE[props.stateSelected].city + ", " + props.stateSelected,
                        react_1.default.createElement("br", null),
                        COLLEGE[props.stateSelected].zip,
                        react_1.default.createElement("br", null),
                        "PHONE: ",
                        COLLEGE[props.stateSelected].phone,
                        react_1.default.createElement("br", null),
                        "FAX: ",
                        COLLEGE[props.stateSelected].fax))))));
}
exports.Header = Header;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2FzaGVyL0RpcGxvbWFSZXF1ZXN0L3BhcnRzL0hlYWRlci9IZWFkZXIuY29tcG9uZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxnREFBeUI7QUFDekIsd0VBQTJEO0FBRTNELElBQU0sT0FBTyxHQUFHO0lBQ1osRUFBRSxFQUFFO1FBQ0EsUUFBUSxFQUFFLHlCQUF5QjtRQUNuQyxJQUFJLEVBQUUsWUFBWTtRQUNsQixHQUFHLEVBQUUsWUFBWTtRQUNqQixLQUFLLEVBQUUsZ0JBQWdCO1FBQ3ZCLEdBQUcsRUFBRSxnQkFBZ0I7S0FDeEI7SUFDRCxFQUFFLEVBQUU7UUFDQSxRQUFRLEVBQUUseUJBQXlCO1FBQ25DLElBQUksRUFBRSxXQUFXO1FBQ2pCLEdBQUcsRUFBRSxPQUFPO1FBQ1osS0FBSyxFQUFFLGNBQWM7UUFDckIsR0FBRyxFQUFFLGNBQWM7S0FDdEI7SUFDRCxFQUFFLEVBQUU7UUFDQSxRQUFRLEVBQUUsK0JBQStCO1FBQ3pDLElBQUksRUFBRSxRQUFRO1FBQ2QsR0FBRyxFQUFFLE9BQU87UUFDWixLQUFLLEVBQUUsY0FBYztRQUNyQixHQUFHLEVBQUUsY0FBYztLQUN0QjtDQUNKLENBQUE7QUFDRCxTQUFnQixNQUFNLENBQUMsS0FBSztJQUN4QixPQUFPLENBQ0g7UUFDSSx1Q0FBSyxTQUFTLEVBQUUsU0FBTyxNQUFNLENBQUMsaUJBQW1CO1lBQzdDLHVDQUFLLFNBQVMsRUFBQyxtQkFBbUI7Z0JBQzlCLHVDQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsU0FBUyxFQUFFLEdBQUcsRUFBQyxNQUFNLEVBQUMsR0FBRyxFQUFDLHFCQUFxQixHQUFHLENBQ3ZFO1lBQ04sdUNBQUssU0FBUyxFQUFDLG1CQUFtQixHQUFPO1lBQ3pDLHVDQUFLLFNBQVMsRUFBQyxtQkFBbUI7Z0JBQzlCLHVDQUFLLFNBQVMsRUFBSyxNQUFNLENBQUMsU0FBUyxTQUFJLE1BQU0sQ0FBQyxlQUFpQjtvQkFDM0Q7O3dCQUVJLHlDQUFNO3dCQUNMLE9BQU8sQ0FBQyxLQUFLLENBQUMsYUFBYSxDQUFDLENBQUMsUUFBUTt3QkFDdEMseUNBQU0sRUFDRixPQUFPLENBQUMsS0FBSyxDQUFDLGFBQWEsQ0FBQyxDQUFDLElBQUksVUFBSyxLQUFLLENBQUMsYUFBZTt3QkFDL0QseUNBQU07d0JBQ0wsT0FBTyxDQUFDLEtBQUssQ0FBQyxhQUFhLENBQUMsQ0FBQyxHQUFHO3dCQUNqQyx5Q0FBTTs7d0JBQ0UsT0FBTyxDQUFDLEtBQUssQ0FBQyxhQUFhLENBQUMsQ0FBQyxLQUFLO3dCQUMxQyx5Q0FBTTs7d0JBQ0EsT0FBTyxDQUFDLEtBQUssQ0FBQyxhQUFhLENBQUMsQ0FBQyxHQUFHLENBQ25DLENBQ0wsQ0FDSixDQUNKLENBQ0QsQ0FDWixDQUFBO0FBQ0wsQ0FBQztBQTVCRCx3QkE0QkMifQ==